import { useAuth0 } from '@auth0/auth0-react';
import { FAMILY_INVITATION_STATUS } from '../constants';
import { useGetFamilyInvitations } from 'features/familyLinkage/hooks/useGetFamilyInvitations';
import { useMemo } from 'react';

export function useGetFamilyCancelledInvitations() {
  const { user } = useAuth0();
  const { data = [], ...rest } = useGetFamilyInvitations();

  const filteredData = useMemo(
    () =>
      data.filter(
        (i) =>
          i.inviter_email.toLowerCase() === user.email.toLowerCase() &&
          i.status === FAMILY_INVITATION_STATUS.CANCELLED
      ),
    [data, user]
  );

  return {
    data: filteredData,
    ...rest,
  };
}
